import React from "react";
import { Icons, IconButton } from "@curves/ui-base";
import { useInBodyContext } from "@icoach/inbody/components/InBodyContext";
import useInBodyApi from "@apis/useInBodyApi";
import { isFunction } from "@util/utils";

const InBodyInterviewPdfDialog = React.forwardRef((props, ref) => {
	const { sourceData: pdfUrl, measureID } = props;
	const { getGeneratedInbodyPDF } = useInBodyApi();
	const { dialogRef } = useInBodyContext();

	const handleOnClick = () => {
		dialogRef.current.openViewPdfDialog(pdfUrl, generatedInbodyPDFApi);
	};

	const generatedInbodyPDFApi = async _fn => {
		await getGeneratedInbodyPDF(measureID);
		isFunction(_fn) && _fn();
	};

	return (
		<React.Fragment>
			{pdfUrl && (
				<IconButton onClick={handleOnClick}>
					<Icons.Download />
				</IconButton>
			)}
		</React.Fragment>
	);
});

export default InBodyInterviewPdfDialog;
